import {useEffect} from "react";

const useScript = function (url) {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;

        document.head.appendChild(script);
    }, [])
};
export default useScript;